module.exports = new __parcel__URL__("noSearchResults.d74f9061.svg").toString();